import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PaymentCardInputBaseComponent } from '@luggagehero/features/ui';

@Component({
  selector: 'lh-payment-card-input',
  templateUrl: './payment-card-input.component.html',
  styleUrls: ['./payment-card-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PaymentCardInputComponent extends PaymentCardInputBaseComponent {}
